import THEME from "../../../theme";
import { fs } from "../utils/styles";

const MONATSNAMEN = ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export default function MonatsTabelle({ monatsentwicklung }) {
  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Monatsübersicht</h3>
      <div style={fs.tabelle}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr><th style={fs.th}>Monat</th><th style={{ ...fs.th, textAlign: "right" }}>Einnahmen</th><th style={{ ...fs.th, textAlign: "right" }}>Ausgaben</th><th style={{ ...fs.th, textAlign: "right" }}>Gewinn</th></tr></thead>
          <tbody>
            {monatsentwicklung.map(m => (
              <tr key={`${m.jahr}-${m.monat}`}>
                <td style={fs.td}>{MONATSNAMEN[m.monat]} {m.jahr}</td>
                <td style={{ ...fs.td, textAlign: "right", color: THEME.colors.success }}>{m.einnahmen.toFixed(2)} €</td>
                <td style={{ ...fs.td, textAlign: "right", color: THEME.colors.danger }}>{m.ausgaben.toFixed(2)} €</td>
                <td style={{ ...fs.td, textAlign: "right", color: m.vorlaeufiges_betriebsergebnis >= 0 ? THEME.colors.success : THEME.colors.danger, fontWeight: 600 }}>{m.vorlaeufiges_betriebsergebnis.toFixed(2)} €</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
